import { jsx as _jsx } from "react/jsx-runtime";
import { Slider } from './Slider';
const USPBanner = ({ containerCls, items, sliderCls, subtitle, title, }) => {
    return (_jsx("div", { className: containerCls, children: _jsx(Slider, { title: title, subtitle: subtitle, items: items, className: sliderCls }) }));
};
export { USPBanner };
